import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { MailX, CheckCircle2 } from "lucide-react";
import api from "../lib/apiClient";

// Signed, login-free unsubscribe landing page: /email/unsubscribe?u=<user>&s=<search id|all>&t=<token>
export default function EmailUnsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("working");
  const [scope, setScope] = useState("");
  useEffect(() => {
    const u = params.get("u"), s = params.get("s"), t = params.get("t");
    if (!u || !s || !t) { setState("invalid"); return; }
    api.post("/email/unsubscribe", { u, s, t }).then(({ data }) => { setScope(data.scope); setState("done"); }).catch(() => setState("invalid"));
  }, [params]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="email-unsubscribe-page">
      <div className="bg-white rounded-3xl border border-line p-8 max-w-md w-full text-center">
        {state === "working" && <p className="text-ink-soft" data-testid="unsub-working">Updating your email preference…</p>}
        {state === "done" && (
          <>
            <CheckCircle2 className="mx-auto text-success" size={40} />
            <h1 className="font-heading font-black text-2xl text-ink mt-3">You're unsubscribed</h1>
            <p className="text-ink-soft mt-2" data-testid="unsub-done">{scope === "all" ? "No more saved-search emails will be sent to this account." : "No more emails for this saved search. Other searches are unchanged."} In-app matches still appear in Ding Me.</p>
          </>
        )}
        {state === "invalid" && (
          <>
            <MailX className="mx-auto text-ink-muted" size={40} />
            <h1 className="font-heading font-black text-2xl text-ink mt-3">This link isn't valid</h1>
            <p className="text-ink-soft mt-2" data-testid="unsub-invalid">The unsubscribe link is incomplete or has changed. You can turn email digests off per search in Ding Me.</p>
          </>
        )}
        <Link to="/alerts" className="inline-flex mt-6 min-h-[44px] items-center px-5 rounded-full bg-brand text-white font-bold" data-testid="unsub-to-dingme">Open Ding Me</Link>
      </div>
    </div>
  );
}
